<script lang="ts">
import { reactive, defineComponent, computed } from '@vue/composition-api';
import { colorFromInitials, getInitials } from '@/_core/utils/misc';

interface IProps {
    name: string;
    tooltip: boolean;
    xSmall: boolean;
    small: boolean;
    medium: boolean;
    large: boolean;
    isInvitedColor: boolean;
    loading: boolean;
}

const ColoredAvatar = defineComponent<IProps>({
    name: 'ColoredAvatar',
    props: {
        name: String,
        tooltip: Boolean,
        xSmall: Boolean,
        small: Boolean,
        medium: Boolean,
        large: Boolean,
        isInvitedColor: Boolean,
        loading: Boolean,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        const color = computed(() => {
            return props.isInvitedColor ? { bgColor: 'grey10Light', fontColor: 'grey50Light' } : colorFromInitials(props.name);
        });

        const userInitials = computed(() => {
            return getInitials(props.name);
        });

        const sizeClass = computed(() => {
            if (props.xSmall) {
                return 'x-small';
            }

            if (props.small) {
                return 'small';
            }

            if (props.medium) {
                return 'medium';
            }

            if (props.large) {
                return 'large';
            }

            return 'large';
        });

        return {
            state,
            color,
            userInitials,
            sizeClass,
        };
    },
});

export default ColoredAvatar;
</script>

<template>
  <v-avatar
    :class="`${sizeClass} ${color.fontColor}--text`"
    :color="loading ? undefined : color.bgColor"
    style="border-radius: 50% !important; cursor: default;"
    class="font-weight-bold"
  >
    <v-progress-circular
      v-if="loading"
      :size="xSmall ? 18 : small ? 24 : medium ? 32 : 40"
      indeterminate
    />
    <v-tooltip v-else-if="tooltip" bottom>
      <template #activator="{ on }">
        <span class="font-weight-bold" v-on="on">{{ userInitials }}</span>
      </template>
      <span>{{ name }}</span>
    </v-tooltip>
    <span v-else>{{ userInitials }}</span>
  </v-avatar>
</template>

<style lang="scss" scoped>
.x-small {
    width: 18px !important;
    min-width: 18px !important;
    height: 18px !important;
    font-size: 8px;
}

.small {
    width: 24px !important;
    min-width: 24px !important;
    height: 24px !important;
    font-size: 10px;
}

.medium {
    width: 32px !important;
    min-width: 32px !important;
    height: 32px !important;
    font-size: 12px;
}

.large {
    width: 40px !important;
    min-width: 40px !important;
    height: 40px !important;
    font-size: 16px;
    font-weight: 700;
}
</style>
